import { MessageService } from 'primeng/components/common/api';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, ConfirmationService } from 'primeng/primeng';
import { CustomerSetBuilderService } from './../../../../services/customer/customer-set-builder.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-customer-set-load',
  templateUrl: './customer-set-load.component.html',
  styleUrls: ['./customer-set-load.component.css']
})
export class CustomerSetLoadComponent implements OnInit {
  queryList: SelectItem[];
  selectedQueryId: number;
  @Output() onSelectQuery: EventEmitter<number> = new EventEmitter();
  @Output() onCloseDialog: EventEmitter<any> = new EventEmitter();

  constructor(
    private customerSetBuilderService: CustomerSetBuilderService,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.getQuery();
  }

  getQuery() {
    this.queryList = [{label: '', value: null}];
    this.customerSetBuilderService.getQuery().subscribe(res => {
      res.forEach(query => {
        this.queryList.push({
          label: `${query.code} (v${query.version})`,
          value: {id: query.id, id_plan: query.id_plan}
        });
      });
    });
  }

  selectQuery() {
    if (this.selectedQueryId) {
      this.onSelectQuery.emit(this.selectedQueryId)
    }
  }

  deleteQuery(queryId: number, queryName: string) {
    this.confirmationService.confirm({
      header: this.translateService.instant('customerSetBuilder.removeSetConfirmTitle', {queryName}),
      message: this.translateService.instant('customerSetBuilder.removeSetConfirmMsg'),
      accept: () => this.customerSetBuilderService.deleteQuery(queryId).subscribe(() => {
        this.translateService.get(['common.success', 'common.operation_success']).subscribe(() => {
          this.messageService.add({
            severity: 'success',
            summary:  this.translateService.instant('common.success'),
            detail:  this.translateService.instant('common.operation_success')
          });
        });
        this.getQuery();
      }),
      acceptLabel: 'Ok'
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-builder/customer-set-load/customer-set-load.component.ts